import React from 'react';
import './Event_about.css';

const Event_about = () => {
    const state = {
        FourKeys_item: [
            {
                title: 'Best practices',
                topics: [
                    'Integrating Typescript with other tools and libraries',
                    'Supporting ES3, ES5 and in future ES6 and beyond - without changing your code',
                    'Backwards compatibility, interoperability, specific support cases',
                    `What's a proper way to API handle response`,
                    'Advantage of type inference',
                ],
            },
            {
                title: 'Underrated features',
                topics: [
                    'Generic function signatures',
                    'Type guards',
                    'Interfaces',
                    'Enums',
                    'Advanced Types',
                    'Vue 3 with typescript',
                    'Union',
                ],
            },
            {
                title: 'Problems solving',
                topics: [
                    'Passing dynamic types from parent components to child components',
                    'Improving type inference',
                    'How to adhere to most recent standards',
                    'Using the strict mode or not',
                    'Any as a type. How could we avoid using any?',
                ],
            },
            {
                title: 'Scaling projects',
                topics: [
                    'Easy, ready and scalable components',
                    'Speeding up bundling/compiling/type checking time',
                    'Strategies for managing large codebases',
                    'Migrating a large legacy codebase to improve maintainability',
                ],
            },
            {
                title: 'This event is',
                topics: [
                    'Opportunity to understand ways to improve your and your Team’s development experience',
                    'Opportunity to catch up with latest implementations and features',
                    'Opportunities to learn best practices',
                    'Opportunity show new tricks and brainstorm ideas for using Typescript during panel disscussion',
                ],
            },
        ],
    };

    const renderGetReady = (item, i) => {
        return (
            <div className="getReady_item" key={`getReady_item-${i}`}>
                <div className='getReady_item--title_block'>
                    <h3 className='getReady_item--title'>{item.title}</h3>
                </div>
                <ul className='getReady_ul'>
                    {item.topics.map(item => <li className='getReady_li p2' key={`getReady_li-${i + item}`}><span>[]</span> {item}</li>)}
                </ul>
            </div>
        );
    };

    return (
        <div className='getReady_wrap'>
            <div className='container getReady'>
                <h2 className='getReady_title colorful'>What event is about</h2>
                <div className='getReady_block'>
                    {state.FourKeys_item.map((item, i) => renderGetReady(item, i))}
                </div>
            </div>
        </div>
    );
};

export default Event_about;